import { useEffect } from "react";
import { DatosAnioInputTable } from "./DatosAnioInputTable";
import { Card } from "@/components/Shared/Card";
import { Separator } from "@/components/ui/separator";
import { useApi } from "@/hooks/useApi";
import { useNavigate, useParams } from "react-router-dom";
import { datosAnioTourSteps } from "./DatosAnioInputTour";
import { useTour } from "@reactour/tour";
import { HelpCircleIcon } from "lucide-react";
import { Button } from "@/components/ui/button";

export function DatosAnioInputDashboard() {
	const { setIsOpen, setCurrentStep, setSteps } = useTour();
	const params = useParams();

	useEffect(() => {
		if (!setSteps) throw new Error("setSteps is not defined");
		setSteps(datosAnioTourSteps);
	}, [setSteps]);

	const initTour = () => {
		setIsOpen(true);
		setCurrentStep(0);
	};

	return (
		<Card>
			<h1 className="text-xl font-bold"></h1>

			<div className="flex justify-between" data-tour-id="title">
				<h1 className="text-xl font-bold">
					{params.anio == "new"
						? "Añadir Datos Anuales"
						: `Modificar Datos Año ${params.anio}`}
				</h1>
				<Button variant="ghost" size="icon" onClick={initTour}>
					<HelpCircleIcon className="size-6" />
				</Button>
			</div>
			<Separator />
			<InputTablePick />
		</Card>
	);
}

function InputTablePick() {
	const params = useParams();
	if (params.anio == "new") {
		return <InputTableNew />;
	}
	if (params.anio == null) {
		return <InputTableNew />;
	}
	return <InputTableEdit />;
}

function InputTableEdit() {
	const api = useApi();
	const params = useParams();
	const navigate = useNavigate();

	if (!params.anio || !Number.isInteger(Number(params.anio))) {
		void navigate("/user/empresa");
		return <div></div>;
	}

	const result = api.useQuery("get", "/v1/Empresa/DatosAnio/{anio}", {
		params: {
			path: {
				anio: params.anio,
			},
		},
	});

	return <DatosAnioInputTable datosAnio={result} />;
}

function InputTableNew() {
	return (
		<DatosAnioInputTable
			datosAnio={{
				isPending: false,
				isError: false,
				data: {
					anio: new Date().getFullYear(),
					cantidadTrabajadores: 0,
					materiaPrima: 0,
					desechos: 0,
					facturacion: 0,

					idEmpresa: -1,
				},
				error: null,
				refetch: () => Promise.resolve(),
			}}
		/>
	);
}
